<div class="text-center" style="height: 91vh;color: #F15D22;">
    <h1 class="p-5">Please choose a correct building and its related floors!</h1>
</div>